import React, { useState } from 'react'
import { useDispatch } from 'react-redux';

export default function AdminPaymentModesCE(props: {
  type: string;
  data?: any;
  open: any;
}) {
     const [pageLoad, setPageLoad] = useState(false);
      const [fetchData, setFetchData] = useState<any>();
       const [open, setOpen] = useState(false);
        const [loading, setLoading] = useState(false);
        const [pageContent, setPageContent] = useState({
            button: 'Create Payment Mode',
          });
          const dispatch = useDispatch();
  return (
    <div>AdminPaymentModesCE</div>
  )
}
